import Swiper, {Pagination, Autoplay, EffectFade, SwiperOptions} from "swiper";
import 'swiper/swiper-bundle.css';
import '../scss/style.scss';

document.addEventListener('DOMContentLoaded', () => {
    if ( document.body.classList.contains('home') ) {
        Swiper.use([Pagination,Autoplay,EffectFade]);

        const swiperOption:SwiperOptions = {
            slidesPerView: 1,
            loop: true,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            speed: 800,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 3000,
            }
        };

        const swiper = new Swiper('.swiper',swiperOption);
        let swiperTimer: string | number | NodeJS.Timeout | null | undefined;

        (document.querySelector('#mv .swiper-button-prev') as any).addEventListener('click', () => {
            if ( swiperTimer != null )
                clearTimeout(swiperTimer);

            swiper.slidePrev();

            swiperTimer = setTimeout(() => {
                swiper.autoplay;
            },5000);
        });

        (document.querySelector('#mv .swiper-button-next') as any).addEventListener('click', () => {
            if ( swiperTimer != null )
                clearTimeout(swiperTimer);

            swiper.slideNext();

            swiperTimer = setTimeout(() => {
                swiper.autoplay;
            },5000);
        });
    }

    // @ts-ignore
    document.querySelector('#sp-menu-btn').addEventListener('click', () => {
        // @ts-ignore
        document.querySelector('#site-header').classList.toggle('menu-open');
    });
})